import { createAsyncThunk } from "@reduxjs/toolkit";
import {  getContractNoteZip } from "../../../helpers/fakebackend_helper";



export const contractNote_zipThunk = createAsyncThunk("contractNote_zipThunk", async ({ params, token }, { rejectWithValue } ) => {
  try {
    const response = await getContractNoteZip( params, token);
    return response;
  } catch (error) {
    // Properly pass the error structure to the reducer
    return rejectWithValue({
      code: error.data?.code || error.code,
      message: error.message,
      data: error.data
    });
  }
});










